// #region IMPORTS 
import { createSlice } from "@reduxjs/toolkit";
// #endregion

// #region CONSTANTS 
const initialState = {
  error: null,
  status: "idle",
  studies: null
};
// #endregion

export const localStudiesSlice = createSlice({
  initialState,
  name: "localStudies",
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setLocalStudies(state, action) {
      const studies = action.payload
      state.studies = studies;
      state.status = "idle"
    },
    setIsLoadingStudies(state) {
      state.status = "loading"
    }
  }
});

// #region ACTIONS
export const {
  setLocalStudies,
  setIsLoadingStudies
} = localStudiesSlice.actions;
// #endregion

// #region SELECTORS 
export const selectStudies = (state) => {
  return state.localStudies.studies;
};

export const selectStudiesStatus = (state) => {
  return state.localStudies.status;
};
// #endregion

export default localStudiesSlice.reducer;
